import React, { Component } from "react";
import { Route, Switch, BrowserRouter, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import Preapps from "./components/Preapps";
import Header from "./components/preapps/Header";
import Login from "./components/login/login";
import KurvLogin from "./components/kurv/KurvLogin";
import KurvForgotPassword from "./components/kurv/KurvForgotPassword";
import KurvChangePassword from "./components/kurv/KurvChangePassword";
import Bank from "./components/bank/Bank";
import Organizations from "./components/organizations/organizations";
import EditOrganization from "./components/organizations/edit-organization/edit-organization";
import Dashboard from "./components/dashboard/dashboard-page";
import Residuals from "./components/residuals/residuals";
import { TrackJS } from "trackjs";
import UnprocessedResidual from "./components/residuals/unprocessed";
import PricingEquipment from "./components/pricing-equipment";
import CreateAppByLink from "./components/blank-app";
import ForgotPassword from "./components/forgot-password/forgot-password";
import ChangePassword from "./components/forgot-password/change-password";
import IdleTimerComponent from "./components/idle-timer/idle-timer";
import MerchantAppList from "./components/merchant-app-list";
import MccList from "./components/mcc/mcc-list";
import RetentionReport from "./components/report/report-one";
import { Logout, UserData } from "./api";
import CustomSignErrorModal from "./components/modals/custom-sign-error-modal/custom-sign-error-modal";
import PhoneVerificationModal from "./v2/components/PhoneVerificationModal";
import config from "./config";
import Equipments from "./components/Equipments";
import MCCPage from "./v2/pages/mcc/index.jsx";
import Layout from "./v2/layout/Layout";
import ApplicationsPage from "./v2/pages/application/ApplicationPage.jsx";
import MerchantPage from "./v2/pages/merchant/MerchantPage.jsx";
import OrganizationsPage from "./v2/pages/organization";
import OrganizationDetailsOnly from "./v2/pages/organization/details-only";
import MerchantDetailsOnly from "./v2/pages/merchant/details-only";
import userStore from "./v2/stores/user";
import useSalesFormStore from "./v2/stores/sales-form";
import CreateAppPage from "./v2/pages/create-app/Index.jsx";
import PreApplication from "./v2/pages/create-app/PreApplication.jsx";
import ProcessorPage from "./v2/pages/processor/index.jsx";
import Templates from "./v2/pages/templates/index.jsx";
import CreateTemplate from "./v2/pages/templates/create";
import DashboardPage from "./v2/pages/dashboard/index.jsx";
import NotificationSettingsPage from "./v2/pages/profile/notification-settings/index.jsx";
import ChargebackPage from "./v2/pages/chargeback/index.jsx";
import TicketsPage from "./v2/pages/tickets/index.jsx";
import EquipmentPage from "./v2/pages/equipment";
import EquipmentModelsPage from "./v2/pages/equipment/models";
import EquipmentCategoriesPage from "./v2/pages/equipment/categories";
import ResidualsPage from "./v2/pages/residuals/index.jsx";
import ManagerApprovalPage from "./v2/pages/manager-approval";
import AnnouncementsPage from "./v2/pages/announcements/index.jsx";
import EMSOfficesPage from "./v2/pages/ems-offices/index.jsx";
import EditPricingEquipmentPage from "./v2/pages/edit-pricing-equipment/index.jsx";
import OldEquipmentPage from "./v2/pages/old-equipment/index.jsx";
import ShippingPage from "./v2/pages/shipping/index.jsx";
import EntityAdminRoute from "./v2/components/EntityAdminRoute/index.jsx";
import ResidualRoute from "./v2/components/ResidualRoute/index.jsx";
import EntitySuperAdminRoute from "./v2/components/EntitySuperAdminRoute/index.jsx";
import PCAdminRoute from "./v2/components/PCAdminRoute/index.jsx";
class Routes extends Component {
  constructor(props) {
    super(props);
    TrackJS.addMetadata("Application", "Stratus");
    TrackJS.install({
      token: "fad66fce73f1425a9f24dfb6e69eaf99",
      application: "PaymentCloud",
    });

    this.state = {
      user: null,
      currentRoute: null,
      preAppCalled: 0,
      customSignErrorModal: false,
      phoneVerificationModal: false,
      phoneVerificationPrefill: null,
      // Server-declared; blocks the app entirely — see render().
      phoneVerificationRequired: false,
      is_ems_user: false,
    };
  }

  getPreAppData = () => {
    this.setState({ preAppCalled: this.state.preAppCalled + 1 });
  };

  logout() {
    Logout()
      .then((response) => {
        window.location = "/";
      })
      .catch((error) => console.log(error));
  }
  checkForSignaturePage = (response) => {
    if (response?.is_impersonating) {
      this.setState({ customSignErrorModal: false });
      return;
    }
    if (
      response?.is_signature_submitted &&
      response?.is_signature_submitted === 1
    ) {
      this.setState({ customSignErrorModal: false });
    } else {
      this.setState({ customSignErrorModal: true });
    }
  };
  componentDidMount = () => {
    // Lets the profile dropdown and the personal details form open the same modal —
    // that is how a user changes the number their sign-in code goes to. The prefill
    // carries a number typed elsewhere, so the user does not retype it here.
    this.unsubscribePhoneModal = userStore.subscribe((state, prev) => {
      if (state.phoneVerificationModal && !prev.phoneVerificationModal) {
        this.setState({
          phoneVerificationModal: true,
          phoneVerificationPrefill: state.phoneVerificationPrefill,
        });
      }
    });
    userStore.getState().setUserLoading(true);
    UserData().then((response) => {
      userStore.getState().setUser(response);
      userStore.getState().setUserLoading(false);
      useSalesFormStore.getState().setIsAuthenticated(true);
      this.setState({
        user: response,
        currentRoute: createBrowserHistory().location.pathname,
        phoneVerificationRequired: !!response?.phone_verification_required,
      });
      this.checkForSignaturePage(response);
      if (response?.is_ems_user) {
        this.setState({ is_ems_user: true });
      }
    });
  };
  componentWillUnmount = () => {
    if (this.unsubscribePhoneModal) {
      this.unsubscribePhoneModal();
    }
  };

  refreshLogin = () => {
    userStore.getState().setUserLoading(true);
    UserData().then((response) => {
      this.setState({
        user: response,
        phoneVerificationRequired: !!response?.phone_verification_required,
      });
      userStore.getState().setUser(response);
      userStore.getState().setUserLoading(false);
      useSalesFormStore.getState().setIsAuthenticated(true);
      this.checkForSignaturePage(response);
      if (response?.is_ems_user) {
        this.setState({ is_ems_user: true });
      }
    });
  };

  tabShowActive(route) {
    this.setState({ currentRoute: route });
  }

  closeCustomSignErrorModal = () => {
    this.setState({ customSignErrorModal: false });
  };

  closePhoneVerificationModal = () => {
    userStore.getState().setPhoneVerificationModal(false);
    this.setState({ phoneVerificationModal: false, phoneVerificationPrefill: null });
  };

  handlePhoneVerified = () => {
    this.closePhoneVerificationModal();
    // Pull the stored number back down, so reopening the modal prefills the new one.
    // For a first-time verification this is also what unblocks the app.
    this.refreshLogin();
  };

  render() {
    const { user, is_ems_user } = this.state;

    // Every session-authenticated endpoint answers 403 until the number is
    // verified, so the prompt replaces the app rather than sitting on top of it.
    //
    // The password routes are the exception. Binding a number takes the account
    // password (PhoneVerificationController::send), so a session that cannot
    // produce one — signed in from an autofilled field, say — needs a way to reset
    // it. This returns before the router, so without the check below it would
    // answer the reset link from the user's email with the wall too. Both routes
    // are unauthenticated server-side (`send-reset-password-email`,
    // `reset-password-token-verify`, `reset-password` carry no `auth`), so letting
    // them render costs the gate nothing. `/password/reset/:slug` redirects into
    // `/changePassword/` server-side, so it is covered by the same check.
    const path = window.location.pathname;
    const bypassesWall =
      path === "/forgotPassword" || path.includes("changePassword");

    if (this.state.phoneVerificationRequired && !bypassesWall) {
      return (
        <PhoneVerificationModal
          isOpen={true}
          mandatory
          user={user}
          onVerified={this.handlePhoneVerified}
        />
      );
    }

    const hostname = window.location.hostname;
    const isKurvDomain = hostname === 'agent.kurvpay.com';
    const LoginComponent = isKurvDomain ? KurvLogin : Login;
    const ForgotPasswordComponent = isKurvDomain ? KurvForgotPassword : ForgotPassword;
    const ChangePasswordComponent = isKurvDomain ? KurvChangePassword : ChangePassword;
    
    return (
      <>
        <BrowserRouter>
          <Switch>
            {/* PreApplication route outside of Layout */}
            {this.state.user == null && (
              <Route
                exact
                path="/application/:agent_url/:app_slug?"
                component={PreApplication}
              />
            )}

            {/* Route for the new v2 namespace */}
            <Route path="/v2">
              <Layout>
                <Switch>
                  <Route
                    exact
                    path="/v2/applications"
                    component={ApplicationsPage}
                  />
                  <Route
                    exact
                    path="/v2/app/:agent_url/:app_slug?"
                    component={PreApplication}
                  />
                  <Route
                    exact
                    path="/v2/create-app/:country"
                    component={CreateAppPage}
                  />
                  <Route exact path="/v2/merchants" component={MerchantPage} />
                  <EntityAdminRoute exact path="/v2/merchants/:id" component={MerchantDetailsOnly} />
                  <EntityAdminRoute exact path="/v2/chargeback" component={ChargebackPage} />
                  <ResidualRoute exact path="/v2/residuals" component={ResidualsPage} />
                  <EntityAdminRoute
                    exact
                    path="/v2/service-tickets/merchant/:powerappId"
                    component={TicketsPage}
                  />
                  <Route exact path="/v2/service-tickets" component={TicketsPage} />
                  <PCAdminRoute
                    exact
                    path="/v2/mcc"
                    component={MCCPage}
                  />
                  <EntitySuperAdminRoute exact path="/v2/offices" component={EMSOfficesPage} />
                  <Route exact path="/v2/organizations" component={OrganizationsPage} />
                  <Route
                    exact
                    path="/v2/organizations/:id"
                    render={(props) => (
                      <React.Suspense fallback={<div>Loading...</div>}>
                        <OrganizationDetailsOnly {...props} />
                      </React.Suspense>
                    )}
                  />
                  <PCAdminRoute exact path="/v2/processors" component={ProcessorPage} />
                  <Route exact path="/v2/templates" component={Templates} />
                  <Route exact path="/v2/templates/create" component={CreateTemplate} />
                  <Route exact path="/v2/templates/:id/edit" component={CreateTemplate} />
                  <EntityAdminRoute exact path="/v2/shipping" component={ShippingPage} />
                  <PCAdminRoute exact path="/v2/announcement" component={AnnouncementsPage} />
                  <EntityAdminRoute exact path="/v2/dashboard" component={DashboardPage} />
                  <Route exact path="/v2/profile/notification-settings" component={NotificationSettingsPage} />

                  <PCAdminRoute exact path="/v2/equipments" component={EquipmentPage} />
                  <PCAdminRoute exact path="/v2/equipments/categories" component={EquipmentCategoriesPage} />
                  <PCAdminRoute exact path="/v2/equipments/:brand_id" component={EquipmentModelsPage} />
                  <EntitySuperAdminRoute exact path="/v2/manager-approval" component={ManagerApprovalPage} />
                  <Route exact path="/v2/edit-pricing-equipment/:editslug" component={EditPricingEquipmentPage} />

                  {this.state.user !== null && (
                    <Route
                      exact
                      path="/v2/create-pre-app"
                      component={PreApplication}
                    />
                  )}
                </Switch>
              </Layout>
            </Route>

            {this.state.user !== null ? (
              <>
                {1 == 1 ? (
                  <Layout>
                    <Switch>
                      <Route
                        exact
                        path="/changePassword/:token"
                        render={() => <Redirect to="/applications" />}
                      />
                      <Route
                        exact
                        path="/applications"
                        component={ApplicationsPage}
                      />
                      {/* Payment Nerds agent_url values carry an "agent/" prefix that /app/:agent_url can't match; the page loads by slug */}
                      <Route
                        exact
                        path="/app/agent/:agent_url/:app_slug"
                        render={({ match }) => (
                          <Redirect
                            to={`/app/${match.params.agent_url}/${match.params.app_slug}`}
                          />
                        )}
                      />
                      <Route
                        exact
                        path="/app/:agent_url/:app_slug?"
                        component={PreApplication}
                      />
                      <Route
                        exact
                        path="/create-app/:country"
                        component={CreateAppPage}
                      />
                      <Route exact path="/merchants" component={MerchantPage} />
                      <EntityAdminRoute exact path="/shipping" component={ShippingPage} />
                      <EntityAdminRoute exact path="/chargeback" component={ChargebackPage} />
                      <ResidualRoute exact path="/residuals" component={ResidualsPage} />
                      <EntityAdminRoute
                        exact
                        path="/service-tickets/merchant/:powerappId"
                        component={TicketsPage}
                      />
                      <Route exact path="/service-tickets" component={TicketsPage} />
                      <PCAdminRoute
                        exact
                        path="/mcc"
                        component={MCCPage}
                      />
                      <EntitySuperAdminRoute exact path="/offices" component={EMSOfficesPage} />
                      <Route exact path="/organizations" component={OrganizationsPage} />
                      <Route
                        exact
                        path="/organizations/:id"
                        render={(props) => (
                          <React.Suspense fallback={<div>Loading...</div>}>
                            <OrganizationDetailsOnly {...props} />
                          </React.Suspense>
                        )}
                      />
                      <PCAdminRoute exact path="/processors" component={ProcessorPage} />
                      <Route exact path="/templates" component={Templates} />
                      <Route exact path="/templates/create" component={CreateTemplate} />
                      <Route exact path="/templates/:id/edit" component={CreateTemplate} />
                      <PCAdminRoute exact path="/announcement" component={AnnouncementsPage} />
                      <EntityAdminRoute exact path="/dashboard" component={DashboardPage} />
                      <Route exact path="/profile/notification-settings" component={NotificationSettingsPage} />
                      <Route exact path="/organization" component={Organizations}/>
                      <PCAdminRoute exact path="/equipments" component={EquipmentPage} />
                      <PCAdminRoute exact path="/equipments/categories" component={EquipmentCategoriesPage} />
                      <PCAdminRoute exact path="/equipments/:brand_id" component={EquipmentModelsPage} />
                      <PCAdminRoute exact path="/old-equipments" component={OldEquipmentPage} />
                      <EntitySuperAdminRoute exact path="/manager-approval" component={ManagerApprovalPage} />
                      <EntitySuperAdminRoute exact path="/manager-approval/:id" component={ManagerApprovalPage} />
                      {/* <Route exact path="/dashboard" component={Dashboard} /> */}
                      {this.state.user !== null && (
                        <Route
                          exact
                          path="/create-pre-app"
                          component={PreApplication}
                        />
                      )}
                      {/* Add other /v2 routes here */}
                    </Switch>
                  </Layout>
                ) : (
                  <div
                    className={`website-wrapper application-page organizationsPage ${this.state?.user?.organization_id == config.paymentcloud.PAYCHEX_ORG_ID ? "paychex" : is_ems_user ? "ems" : ""}`}
                  >
                    <Header
                      getPreAppData={this.getPreAppData.bind(
                        this,
                      )}
                      user={user}
                      onLogout={this.logout}
                      currentRoute={this.state.currentRoute}
                      tabShowActive={(route) =>
                        this.tabShowActive(route)
                      }
                    />
                    <Route
                      exact
                      path="/applications"
                      x="100"
                      render={(props) => (
                        <Preapps
                          user={user}
                          preAppCalled={
                            this.state.preAppCalled
                          }
                          {...props}
                          currentRoute={
                            this.state.currentRoute
                          }
                          tabShowActive={(route) =>
                            this.tabShowActive(route)
                          }
                        />
                      )}
                    />
                    <Route
                      exact
                      path="/app/:text"
                      component={Preapps}
                    />
                    <Route exact path="/bank" component={Bank} />
                    <Route
                      exact
                      path="/organization"
                      component={Organizations}
                    />
                    <EntityAdminRoute
                      exact
                      path="/dashboard"
                      component={Dashboard}
                    />
                    <ResidualRoute
                      exact
                      path="/residuals"
                      component={Residuals}
                    />
                    <ResidualRoute
                      exact
                      path="/residuals/unprocessed"
                      component={UnprocessedResidual}
                    />
                    <Route
                      exact
                      path="/pricing-equipment"
                      component={PricingEquipment}
                    />
                    <Route
                      exact
                      path="/organization/:organization_id"
                      component={EditOrganization}
                    />
                    <Route
                      exact
                      path="/applications/:prevet_editslug"
                      component={Preapps}
                    />
                    <Route
                      exact
                      path="/create-blank-app/:org_slug/:agent_url/:template_id/:ems_office?"
                      component={CreateAppByLink}
                    />
                    <Route
                      exact
                      path="/merchants"
                      component={(props) => (
                        <MerchantAppList
                          {...props}
                          currentRoute={
                            this.state.currentRoute
                          }
                          tabShowActive={(route) =>
                            this.tabShowActive(route)
                          }
                        />
                      )}
                    />
                    <PCAdminRoute exact path="/mcc" component={MccList} />
                    <PCAdminRoute
                      exact
                      path="/equipments"
                      component={Equipments}
                    />
                    <Route
                      exact
                      path="/retention/report"
                      component={RetentionReport}
                    />
                  </div>
                )}
              </>
            ) : (
              <>
                <Route
                  exact
                  path="/"
                  component={(props) => (
                    <LoginComponent
                      {...props}
                      refreshLogin={this.refreshLogin}
                    />
                  )}
                />
                {/* Payment Nerds agent_url values carry an "agent/" prefix that /app/:agent_url can't match; the page loads by slug */}
                <Route
                  exact
                  path="/app/agent/:agent_url/:app_slug"
                  render={({ match }) => (
                    <Redirect
                      to={`/app/${match.params.agent_url}/${match.params.app_slug}`}
                    />
                  )}
                />
                <Route
                  exact
                  path="/app/:agent_url/:app_slug?"
                  component={PreApplication}
                />
                <Route
                  exact
                  path="/forgotPassword"
                  component={ForgotPasswordComponent}
                />
                <Route
                  exact
                  path="/changePassword/:token"
                  component={ChangePasswordComponent}
                />
                <Route
                  exact
                  path="/create-blank-app/:org_slug/:agent_url/:template_id/:ems_office?"
                  component={CreateAppByLink}
                />
              </>
            )}
          </Switch>
        </BrowserRouter>
        {this.state.customSignErrorModal && (
          <CustomSignErrorModal
            show={this.state.customSignErrorModal}
            closeModal={this.closeCustomSignErrorModal}
            data={this.state.user}
          />
        )}
        {/* Held back while the signature modal is up so the two never stack. */}
        {this.state.phoneVerificationModal && !this.state.customSignErrorModal && (
          <PhoneVerificationModal
            isOpen={true}
            user={user}
            prefill={this.state.phoneVerificationPrefill}
            onDismiss={this.closePhoneVerificationModal}
            onVerified={this.handlePhoneVerified}
          />
        )}
        <IdleTimerComponent />
      </>
    );
  }
}
export default Routes;
